import React from 'react';

import FormInputField from '@modules/common/components/Field/FormInputField';

import { FormInputFieldProps } from './FormInputField';

export const EmailFormField = React.memo((props: FormInputFieldProps) => {
  return (
    <FormInputField
      className="email"
      autoComplete="email"
      icon="mail"
      iconPosition="left"
      placeholder="E-mail address"
      fieldName="email"
      type="email"
      {...props}
      fluid
    />
  );
});
